import * as api from '../../services/notifyHistory'

export const FETCH_MSGLOGS = 'FETCH_MSGLOGS';


export const fetchMsglogs = (params, pagination, sort, extra) => {
    return {
        type: FETCH_MSGLOGS,
        payload: {
            promise: api.findLogs(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/msglog.js